import { adminFetch } from "./base";
import type { ModuleFlag } from "@/lib/modules/types";

// ---------------------------------------------------------------------------
// Request / response shapes
// ---------------------------------------------------------------------------

interface ModuleListResponse {
  readonly modules: ModuleFlag[];
}

interface UpdateModuleInput {
  readonly isEnabled?: boolean;
  readonly regions?: string[];
}

// ---------------------------------------------------------------------------
// API client
// ---------------------------------------------------------------------------

export const modulesApi = {
  list(): Promise<ModuleListResponse> {
    return adminFetch<ModuleListResponse>("/api/admin/modules");
  },

  update(
    moduleKey: string,
    data: UpdateModuleInput,
  ): Promise<ModuleFlag> {
    return adminFetch<ModuleFlag>(`/api/admin/modules/${moduleKey}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    });
  },
} as const;
